import React, { useEffect, useState } from "react"
import "./EditInstitution.scss"
import { useLocation, useNavigate } from "react-router-dom"
import UniversityApi from "Api/UniversityApi"
import * as Yup from "yup"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import { InputNumber } from "primereact/inputnumber"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import Country from "utils/Data/Country"
import InstituteApi from "Api/InstituteApi"
import { set } from "lodash"
import { toast, ToastContainer } from 'react-toastify'


const EditInstitution = () => {
  document.title = "Edit Institution"

  const accessToken = localStorage.getItem("accessToken")
  const navigate = useNavigate("")
  const location = useLocation("")
  const institutionData = location?.state
  const userData = JSON.parse(localStorage.getItem("userData"))
  const [errors, setErrors] = useState({})
  
  const [dialCode, phoneNumber] = institutionData?.phone
    ? institutionData?.phone?.split("-")
    : [null, null]
    const [universityData, setUniversityData] = useState([])

  const refinedInstitutionData = {
    ...institutionData,
    category: {
      name:
        institutionData?.category?.charAt(0)?.toUpperCase() +
        institutionData?.category?.slice(1),
      code: institutionData?.category?.charAt(0)?.toUpperCase() +
      institutionData?.category?.slice(1),
    },
    type: {
      name:
        institutionData?.type?.charAt(0)?.toUpperCase() +
        institutionData?.type?.slice(1),
      code: institutionData?.type,
    },
    country: {
      name: institutionData?.country,
      code: institutionData?.country,
      
    },

    ugcApproval: {
      name: institutionData?.ugcApproval ? "Yes" : "No",
      code: institutionData?.ugcApproval ? "Yes" : "No",
    },
    aiuAffiliation: {
      name: institutionData?.aiuAffiliation ? "Yes" : "No",
      code: institutionData?.aiuAffiliation ? "Yes" : "No",
    },
    verifiedStatus: {
      name:
        institutionData?.verifiedStatus.charAt(0)?.toUpperCase() +
        institutionData?.verifiedStatus?.slice(1),
      code:
        institutionData?.verifiedStatus.charAt(0)?.toUpperCase() +
        institutionData?.verifiedStatus?.slice(1),
    },
    verifiedReason: institutionData?.verifiedReason
      ? institutionData?.verifiedReason
      : "",
  }

  console.log("refinedInstitutionData", refinedInstitutionData)

  const [updatedInstitutionData, setUpdatedInstitutionData] = useState(
    refinedInstitutionData,
  )

  const handleInstitutionDataChange = (name, value) => {
    setUpdatedInstitutionData(prevState => ({
      ...prevState,
      [name]: value,
    }))
    setErrors({ ...errors, [name]: "" })
  }

  const breadcrumbItems = [
    { label: "Home" },
    { label: "Institution" },
    { label: "Edit Institution" },
  ]

  const typeOptions = [
    { name: "Central", code: "Central" },
    { name: "State", code: "State" },
    { name: "Private", code: "Private" },
    { name: "Deemed", code: "Deemed" },
    { name: "Autonomous", code: "Autonomous" },
    { name: "Government", code: "Government" },
  ]
  const categoryOptions = [
    { name: "Medical", code: "Medical" },
    { name: "Engineering", code: "Engineering" },
    { name: "Arts", code: "Arts" },
    { name: "Science", code: "Science" },
    { name: "Commerce", code: "Commerce" },
    { name: "Law", code: "Law" },
    { name: "Management", code: "Management" },
    { name: "Architecture", code: "Architecture" },

  ]

  const verficationOption = [
    { name: "Approve", code: "Approve" },
    { name: "Reject", code: "Reject" },
    { name: "Pending", code: "Pending" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]

  

  const getUniversityMenu = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniversityData(res.data.university)
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    getUniversityMenu()
  }, [accessToken])

  const ValidateInstitution = Yup.object().shape({
    institutionName: Yup.string().required("Institution name is required"),
    displayName: Yup.string().required("Display name is required"),
    category: Yup.string()
      .oneOf(
        [
          "medical",
          "engineering",
          "arts",
          "science",
          "commerce",
          "law",
          "management",
        ],
        "Invalid category",
      )
      .required("Category is required"),
    yearEstablished: Yup.number()
      .typeError("Established year must be a valid number")
      .min(1800, "Year cannot be before 1800")
      .max(new Date().getFullYear(), "Year cannot be in the future")
      .required("Established year is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string()
      .matches(/^\d{6}$/, "Please enter a valid 6-digit zip code")
      .required("PinCode is required"),
    address: Yup.string().required("Address is required"),
    // phone: Yup.string()
    //   .matches(/^\+\d{1,3}[-\s]?\d{10}$/, "Invalid phone number")
    //   .required("Phone number is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    officialWebsite: Yup.string().required("officialWebsite is required"),
    // description: Yup.string().required("Description is required"),
    nirfRanking: Yup.string().required("nirfRanking is required"),
    indiaToday2023Ranking: Yup.string().required(
      "indiaToday2023Ranking is required",
    ),
    timesRanking2024: Yup.string().required("timesRanking2024 is required"),
    campusSize: Yup.string().required("campusSize is required"),
    noOfStudents: Yup.string().required("noOfStudents is required"),
    noOfDepartments: Yup.string().required("noOfDepartments is required"),
    noOfCourses: Yup.string().required("noOfCourses is required"),
    totalFaculty: Yup.string().required("totalFaculty is required"),
    ugcApproval: Yup.boolean()
      .oneOf([true, false], "Invalid UGC approval")
      .required("Choose UGC Approval"),
    aiuAffiliation: Yup.boolean()
      .oneOf([true, false], "Invalid AIU Affiliation")
      .required("Choose AIU Affiliation"),
    highlights: Yup.string().required("highlights is required"),
    aboutContent: Yup.string().required("aboutContent is required"),
  })

  const [loading, setLoading] = useState(false)

  const updateUniversity = () => {
    const { phoneCode, ...otherUniversityData } = updatedInstitutionData
    const payload = {
      ...otherUniversityData,
      university: otherUniversityData?.university?._id,
      country: otherUniversityData?.country?.name,
      state: otherUniversityData?.state,
      city: otherUniversityData?.city,
      type: otherUniversityData?.type?.name?.toLowerCase(),
      // phone:
      //   otherUniversityData?.country?.dialCode +
      //   "-" +
      //   otherUniversityData?.phone,
      category: otherUniversityData?.category?.name.toLowerCase(),
      isVerfied: otherUniversityData?.isVerified === "Approve" ? true : false,
      verifiedStatus: otherUniversityData?.verifiedStatus?.name?.toLowerCase()
        ? otherUniversityData?.verifiedStatus?.name?.toLowerCase()
        : "pending",
      verifiedReason: otherUniversityData?.verifiedReason
        ? otherUniversityData?.verifiedReason
        : "",
        aiuAffiliation:
        otherUniversityData?.aiuAffiliation?.name === "Yes" ? true : false,
      ugcApproval:
        otherUniversityData?.ugcApproval?.name === "Yes" ? true : false,
      institutionId: institutionData?._id,
    }

    setLoading(true)

    ValidateInstitution.validate(payload, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }

        InstituteApi.updateInstitution(payload, config)
          .then(response => {
            if (response.data.status) {
              setLoading(false)
              setTimeout(() => {
                navigate("/institutionlist")
              }, 1000)
              toast.success(response.data.message)



            }
          })
          .catch(error => {
            setLoading(false)
            toast.error(error.response.data.message)

            console.error("Error adding university:", error)
          })
      })
      .catch(err => {
        setLoading(false)

        const validationErrors = {}
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
      })
  }

  return (
    <div className="edit-institution">
      <ToastContainer />
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Edit Institution"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="institution-edit-form ">
                <div className="institution-edit-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={updatedInstitutionData.university}
                      onChange={e => {
                        handleInstitutionDataChange("university", e.value)
                      }}
                      options={universityData}
                      optionLabel="universityName"
                      placeholder="Select University"
                      filter
                    />
                    {errors.university && (
                      <small className="error">{errors.university}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="institutionName">Institution Name</label>
                  <div className="inp-err">
                    <InputText
                      id="institutionName"
                      value={updatedInstitutionData.institutionName}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "institutionName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Institution Name"
                    />
                    {errors.institutionName && (
                      <small className="error">{errors.institutionName}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="displayName">Display Name</label>

                  <div className="inp-err">
                    <InputText
                      id="displayName"
                      value={updatedInstitutionData.displayName}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "displayName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Display Name"
                    />
                    {errors.displayName && (
                      <small className="error">{errors.displayName}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="category">Category</label>
                  <div className="inp-err">
                    <Dropdown
                      value={updatedInstitutionData.category}
                      onChange={e =>
                        handleInstitutionDataChange("category", e.value)
                      }
                      options={categoryOptions}
                      optionLabel="name"
                      placeholder="Select Category"
                      filter
                    />
                    {errors.category && (
                      <small className="error">{errors.category}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="type">Type</label>

                  <div className="inp-err">
                    <Dropdown
                      value={updatedInstitutionData.type}
                      onChange={e =>
                        handleInstitutionDataChange("type", e.value)
                      }
                      options={typeOptions}
                      optionLabel="name"
                      placeholder="Select Type"
                      filter
                    />
                    {errors.type && (
                      <small className="error">{errors.type}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="yearEstablished"> Year Established</label>

                  <div className="inp-err">
                    <Calendar
                      id="yearEstablished"
                      value={
                        updatedInstitutionData.yearEstablished
                          ? new Date(updatedInstitutionData.yearEstablished, 0)
                          : null
                      }
                      onChange={e => {
                        const selectedYear = e.value
                          ? new Date(e.value).getFullYear()
                          : null
                        handleInstitutionDataChange(
                          "yearEstablished",
                          selectedYear,
                        )
                      }}
                      view="year"
                      dateFormat="yy"
                      placeholder="Select  Year Established"
                    />

                    {errors.yearEstablished && (
                      <small className="error">{errors.yearEstablished}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="country">Country</label>
                  <div className="inp-err">
                    <Dropdown
                      id="country"
                      value={updatedInstitutionData.country}
                      onChange={e =>
                        handleInstitutionDataChange("country", e.value)
                      }
                      options={Country}
                      // itemTemplate={countryOptionTemplate}
                      optionLabel="name"
                      placeholder="Select Country"
                      filter
                      className="inp-field-box"
                    />

                    {errors.country && (
                      <small className="error">{errors.country}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="state">State</label>
                  <div className="inp-err">
                    <InputText
                      id="state"
                      value={updatedInstitutionData.state}
                      onChange={e =>
                        handleInstitutionDataChange("state", e.target.value)
                      }
                      placeholder="Enter State"
                    />
                    {errors.state && (
                      <small className="error">{errors.state}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="username">City</label>
                  <div className="inp-err">
                    <InputText
                      id="city"
                      placeholder="Enter City"
                      value={updatedInstitutionData.city}
                      onChange={e =>
                        handleInstitutionDataChange("city", e.target.value)
                      }
                    />
                    {errors.city && (
                      <small className="error">{errors.city}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="pinCode"> Pin code</label>
                  <div className="inp-err">
                    <InputNumber
                      id="pinCode"
                      value={updatedInstitutionData.pinCode}
                      onChange={e =>
                        handleInstitutionDataChange("pinCode", e.value)
                      }
                      useGrouping={false}
                      placeholder="Enter Pin Code"
                    />
                    {errors.pinCode && (
                      <small className="error">{errors.pinCode}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="address">Address</label>
                  <div className="inp-err">
                    <InputText
                      id="address"
                      value={updatedInstitutionData.address}
                      onChange={e =>
                        handleInstitutionDataChange("address", e.target.value)
                      }
                      placeholder="Enter Address"
                    />
                    {errors.address && (
                      <small className="error">{errors.address}</small>
                    )}
                  </div>
                </div>
                {/* <div className="institution-edit-inp">
                  <label htmlFor="phoneNumber">Phone</label>

                  <div className="inp-err">
                    <div className="p-inputgroup  phone-number ">
                      <Dropdown
                        id="phone"
                        value={updatedInstitutionData.country}
                        // onChange={e =>
                        // }
                        options={Country}
                        optionLabel="dialCode"
                        placeholder="+XX"
                        filter
                      />
                      <InputNumber
                        id="phoneNumber"
                        value={updatedInstitutionData.phone}
                        onChange={e =>
                          handleInstitutionDataChange("phone", e.value)
                        }
                        useGrouping={false}
                        placeholder="Enter Phone Number"
                      />
                    </div>
                    {errors.phone && (
                      <small className="error">{errors.phone}</small>
                    )}
                  </div>
                </div> */}
                <div className="institution-edit-inp">
                  <label htmlFor="email">Email</label>
                  <div className="inp-err">
                    <InputText
                      id="email"
                      value={updatedInstitutionData.email}
                      onChange={e =>
                        handleInstitutionDataChange("email", e.target.value)
                      }
                      placeholder="Enter Email"
                    />
                    {errors.email && (
                      <small className="error">{errors.email}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="officialWebsite">Official Website</label>

                  <div className="inp-err">
                    <InputText
                      id="officialWebsite"
                      value={updatedInstitutionData.officialWebsite}
                      onChange={e =>
                        handleInstitutionDataChange("officialWebsite", e.target.value)
                      }
                      placeholder="Enter Official Website"
                    />
                    {errors.officialWebsite && (
                      <small className="error">{errors.officialWebsite}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="campusSize" className="label">
                    Campus Size
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="campusSize"
                      value={institutionData.campusSize}
                      onChange={e =>
                        handleInstitutionDataChange("campusSize", e.target.value)
                      }
                      placeholder="Enter CampusSize"
                      className="inp-field-box"
                    />
                    {errors.campusSize && (
                      <small className="error">{errors.campusSize}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="noOfStudents" className="label">
                    No Of Students
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="noOfStudents"
                      value={institutionData.noOfStudents}
                      onChange={e =>
                        handleInstitutionDataChange("noOfStudents", e.value)
                      }
                      placeholder="Enter No Of Students"
                      className="inp-field-box"
                    />
                    {errors.noOfStudents && (
                      <small className="error">{errors.noOfStudents}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="noOfDepartments" className="label">
                    No Of Departments
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="noOfDepartments"
                      value={institutionData.noOfDepartments}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "noOfDepartments",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Departments"
                      className="inp-field-box"
                    />
                    {errors.noOfDepartments && (
                      <small className="error">{errors.noOfDepartments}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="noOfCourses" className="label">
                    No Of Courses
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="noOfCourses"
                      value={institutionData.noOfCourses}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "noOfCourses",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Courses"
                      className="inp-field-box"
                    />
                    {errors.noOfCourses && (
                      <small className="error">{errors.noOfCourses}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="totalFaculty" className="label">
                    Total Faculty
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalFaculty"
                      value={institutionData.totalFaculty}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "totalFaculty",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Total Faculty"
                      className="inp-field-box"
                    />
                    {errors.totalFaculty && (
                      <small className="error">{errors.totalFaculty}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="nirfRanking" className="label">
                    NIRF Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="nirfRanking"
                      value={institutionData.nirfRanking}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "nirfRanking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter NIRF Ranking"
                      className="inp-field-box"
                    />
                    {errors.nirfRanking && (
                      <small className="error">{errors.nirfRanking}</small>
                    )}
                  </div>
                </div>

                <div className="institution-edit-inp">
                  <label htmlFor="indiaToday2023Ranking" className="label">
                    India Today 2023 Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="indiaToday2023Ranking"
                      value={institutionData.indiaToday2023Ranking}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "indiaToday2023Ranking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter India Today 2023 Ranking"
                      className="inp-field-box"
                    />
                    {errors.indiaToday2023Ranking && (
                      <small className="error">
                        {errors.indiaToday2023Ranking}
                      </small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="timesRanking2024" className="label">
                    Times Ranking 2024
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="timesRanking2024"
                      value={institutionData.timesRanking2024}
                      onChange={e =>
                        handleInstitutionDataChange("timesRanking2024", e.value)
                      }
                      placeholder="Enter Times Ranking 2024"
                      className="inp-field-box"
                    />
                    {errors.timesRanking2024 && (
                      <small className="error">{errors.timesRanking2024}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="ugcApproval" className="label">
                    UGC Approval
                  </label>
                  <div className="inp-err ">
                    <Dropdown
                      value={updatedInstitutionData.ugcApproval}
                      onChange={e =>
                        handleInstitutionDataChange("ugcApproval", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select UGC Affiliation"
                      className="inp-field-box"
                    />
                    {errors.ugcApproval && (
                      <small className="error">{errors.ugcApproval}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="aiuAffiliation" className="label">
                    AIU Affiliation
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={updatedInstitutionData.aiuAffiliation}
                      onChange={e =>
                        handleInstitutionDataChange("aiuAffiliation", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select AIU Affiliation"
                      className="inp-field-box"
                    />
                    {errors.aiuAffiliation && (
                      <small className="error">{errors.aiuAffiliation}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="highlights" className="label">
                    Highlights
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="highlights"
                      value={institutionData.highlights}
                      onChange={e =>
                        handleInstitutionDataChange("highlights", e.target.value)
                      }
                      placeholder="Enter Highlights"
                      className="inp-field-box"
                    />
                    {errors.highlights && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>
                <div className="institution-edit-inp">
                  <label htmlFor="aboutContent" className="label">
                    About Content
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="aboutContent"
                      value={institutionData.aboutContent}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "aboutContent",
                          e.target.value,
                        )
                      }
                      placeholder="Enter About Content"
                      className="inp-field-box"
                    />
                    {errors.aboutContent && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>

                {/* <div className="institution-edit-inp">
                  <label htmlFor="description">Description</label>

                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={updatedInstitutionData.description}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "description",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Description"
                    />
                    {errors.description && (
                      <small className="error">{errors.description}</small>
                    )}
                  </div>
                </div> */}
                {/* <div className="institution-edit-inp">
                  <label htmlFor="staffStrength">Staff Strength</label>
                  <div className="inp-err">
                    <InputNumber
                      id="staffStrength"
                      value={updatedInstitutionData.staffStrength}
                      onChange={e =>
                        handleInstitutionDataChange("staffStrength", e.value)
                      }
                      useGrouping={false}
                      placeholder="Enter Staff Strength"
                    />
                    {errors.staffStrength && (
                      <small className="error">{errors.staffStrength}</small>
                    )}
                  </div>
                </div> */}
                {/* <div className="institution-edit-inp">
                  <label htmlFor="studentStrength">Student Strength</label>
                  <div className="inp-err">
                    <InputNumber
                      id="studentStrength"
                      value={updatedInstitutionData.studentStrength}
                      onChange={e =>
                        handleInstitutionDataChange("studentStrength", e.value)
                      }
                      useGrouping={false}
                      placeholder="Enter Student Strength"
                    />
                    {errors.studentStrength && (
                      <small className="error">{errors.studentStrength}</small>
                    )}
                  </div>
                </div> */}

                {userData.role === "manager" && (
                  <>
                    <div className="institution-edit-inp">
                      <label htmlFor="verifiedStatus" className="label">
                        Verification
                      </label>
                      <div className="inp-err ">
                        <Dropdown
                          id="verifiedStatus"
                          value={updatedInstitutionData.verifiedStatus}
                          onChange={e =>
                            handleInstitutionDataChange(
                              "verifiedStatus",
                              e.value,
                            )
                          }
                          options={verficationOption}
                          optionLabel="name"
                          placeholder="Select Verification Status"
                          className="inp-field-box"
                        />
                        {errors.verifiedStatus && (
                          <small className="error">
                            {errors.verifiedStatus}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="institution-edit-inp">
                      <label htmlFor="verifiedReason" className="label">
                        Verification Reason
                      </label>
                      <div className="inp-err">
                        <InputText
                          id="verifiedReason"
                          value={updatedInstitutionData.verifiedReason}
                          onChange={e =>
                            handleInstitutionDataChange(
                              "verifiedReason",
                              e.target.value,
                            )
                          }
                          placeholder="Enter Verification Reason"
                          className="inp-field-box"
                        />
                        {errors.verifiedReason && (
                          <small className="error">
                            {errors.verifiedReason}
                          </small>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    updateUniversity()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Update"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EditInstitution
